import(/* webpackMode: "eager" */ "/vercel/path0/src/app/connections/page.tsx");
